import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { Redirect } from 'react-router-dom';
import { cssTransition, toast, ToastContainer } from 'react-toastify';
import SweetAlert from 'sweetalert-react';

import 'react-toastify/dist/ReactToastify.css';

import { APIHandler, DataHandler, Email, Forgot, Register, StorageHandler } from 'C4';
import { storageKeys, userKeys } from 'settings';

const checkInputValidityFields = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = Array.from(selects);

  Array.from(inputs).forEach((input) => {
    inputArray.push(input);
  });

  const emptyFields = [];
  Array.from(inputs).forEach((input) => {
    if (input.checkValidity() === false) {
      let name = input.name.replace(/reg_/g, '').replace(/_/g, ' ');
      if (name === 'custom 1') {
        name = 'salutation';
      }
      if (name === 'passwordConfirm') {
        name = 'confirm password';
      }
      emptyFields.push(name);
    }
  });

  Array.from(selectArray).forEach((select) => {
    if (select.selectedIndex === 0) {
      const name = select.name.replace(/reg_/g, '').replace(/_/g, ' ');
      emptyFields.push(name);
    }
  });

  return emptyFields;
};

const checkInputValidity = () => {
  const inputs = document.getElementsByTagName('input');
  const inputArray = [];
  const selects = document.getElementsByTagName('select');
  const selectArray = [];

  Array.from(inputs).forEach((input) => {
    inputArray.push(input);
  });

  Array.from(selects).forEach((select) => {
    selectArray.push(select);
    // console.log('select', select, select.selectedIndex);
  });

  return inputArray.every((val) => val.checkValidity() === true) && selectArray.every((val) => val.selectedIndex !== 0);
};

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export const userInputBlank = {
  email: '',
  reg_email: '',
  reg_password: '',
  reg_passwordConfirm: '',
  reg_first_name: '',
  reg_last_name: '',
  reg_title: '',
  reg_agency_name: '',
  reg_host_agency_name: '',
  reg_city: '',
  reg_state: '',
  reg_country: '',
  reg_zip_code: '',

  reg_segment_leisure: false,
  reg_segment_corporate: false,
  reg_segment_group: false,
  reg_agency_affiliation: '',

  reg_marketing_opt_in: false,
};

export default class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userInput: userInputBlank,
      animation: {
        loadingAnim: false,
        loadingAnimRegister: false,
      },
      message: '',
      display: 'login',
      redirect: '',
      appId: 0,
      admission_message: '',
      verified_message: '',
      resend_link: '',
    };

    document.body.classList.add('no-scroll');

    StorageHandler.exists(storageKeys.user).then((res) => {
      if (this.props.path === '/quick-register') {
      } else if (this.props.path === '/quick-register-mobile') {
      } else if (this.props.path === '/register-mobile') {
      } else if (this.props.path === '/register') {
      } else if (this.props.path === '/forgot-password') {
      } else if (this.props.path !== '/logout' && res) {
        this.setState({ redirect: '/main' });
      } else {
        StorageHandler.removeKeys(userKeys);
        StorageHandler.remove(storageKeys.accessToken);
        StorageHandler.remove(storageKeys.refreshToken);
      }
    });

    this.login = this.login.bind(this);
    this.loginHandler = this.loginHandler.bind(this);
    this.registerHandler = this.registerHandler.bind(this);
    this.registerHandlerFirebase = this.registerHandlerFirebase.bind(this);
    this.registerExistingHandler = this.registerExistingHandler.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.changeItemHandler = this.changeItemHandler.bind(this);
    this.backHandler = this.backHandler.bind(this);
    this.setAnim = this.setAnim.bind(this);
    this.signUpRoute = this.signUpRoute.bind(this);
    this.forgotPasswordRoute = this.forgotPasswordRoute.bind(this);
    this.forgotHandler = this.forgotHandler.bind(this);
  }

  componentWillMount() {
    DataHandler.matchAppId().then((id) => {
      this.setState({ appId: id });
    });

    if (this.props.path === '/register') {
      this.loadUserData();
      this.setState({ display: 'registerQuick' });
    }

    if (this.props.path === '/forgot-password') {
      this.setState({ display: 'forgot' });
    }

    if (this.props.path === '/register-mobile') {
      this.setState({ display: 'registerPassword' });
    }

    if (this.props.path === '/quick-register') {
      // Load all user data from storage
      this.loadUserData();
      this.setState({ display: 'registerQuick' });
    }

    if (this.props.path === '/quick-register-mobile') {
      // Load all user data from storage
      this.loadUserDataMobile();
      this.setState({ display: 'registerQuick' });
    }
  }

  setAnim(type, value) {
    const { animation } = this.state;
    animation[type] = value;
    this.setState({ animation });
  }

  setMessage(message) {
    this.setState({ message });
    document.querySelector('.form__message').style.color = 'red';
    document.querySelector('.form__message').style.opacity = 1;
    document.querySelector('.form__message').style.color = 'black';
  }

  loadUserData() {
    StorageHandler.load(storageKeys.user).then((user) => {
      const { userInput } = this.state;
      console.log('user', user);
      if (user) {
        userInput.reg_email = user.email;
        userInput.reg_first_name = user.first_name;
        userInput.reg_last_name = user.last_name;
        userInput.reg_agency_name = user.agency_name;
        userInput.reg_city = user.city;
        userInput.reg_country = user.country;
        userInput.reg_state = user.state;
        userInput.reg_zip_code = user.zip_code;
        userInput.reg_title = user.title;
        userInput.reg_host_agency_name = user.host_agency_name;
        userInput.reg_agency_affiliation = user.agency_affiliation;
      } else {
        let email = localStorage.getItem('email');
        email = JSON.parse(email);
        email = email.rawData;
        userInput.reg_email = email;
      }
      this.setState({ userInput });
    });
  }

  loadUserDataMobile() {
    const { userInput } = this.state;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const email = urlParams.get('email');

    userInput.reg_email = email;
    this.setState({ userInput });
  }

  backHandler() {
    this.setState({
      display: 'login',
      message: '',
    });
    document.querySelector('.form__message').style.opacity = 0;
    this.setAnim('loadingAnim', false);
  }

  signUpRoute() {
    this.setState({ display: 'registerPassword' });
  }

  quickRegister() {
    this.setState({ display: 'quickRegister' });
  }

  forgotPasswordRoute() {
    this.setState({ display: 'forgot' });
  }

  login(userInfo, saveInfo, customRedir) {
    if (saveInfo) {
      StorageHandler.save(storageKeys.user, userInfo.response, 2592000000);
    }
    document.body.classList.remove('no-scroll');
    if (customRedir) {
      this.setState({ redirect: customRedir });
    } else {
      this.setState({ redirect: '/main/' });
    }
  }

  loginHandler(event) {
    const submit = event.target;
    submit.disabled = true;
    if (checkInputValidity()) {
      event.preventDefault();
      const { email, password } = this.state.userInput;

      StorageHandler.exists(storageKeys.user) // Check if userInfo is in localStorage
        .then((res) => {
          if (!res) {
            this.setAnim('loadingAnim', true);

            APIHandler.loginFirebaseUser(email, password).then((firebaseUser) => {
              if (firebaseUser.error) {
                let error = 'The password you entered is incorrect.';
                if (firebaseUser.error.message === 'EMAIL_NOT_FOUND') {
                  error = "The email you entered doesn't appear to belong to an account";
                }
                toast.error(error, {
                  position: 'top-center',
                  transition: Zoom,
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                });
                submit.disabled = false;
                this.setAnim('loadingAnim', false);
              } else {
                StorageHandler.save(storageKeys.refreshToken, firebaseUser.refreshToken);
                StorageHandler.save(storageKeys.idToken, firebaseUser.idToken, 180000);

                // Standard login flow
                // Will only show one time to create profile
                DataHandler.matchAppId().then((appId) => {
                  APIHandler.getUserOld(appId, email) // Fetches userInfo object from the API if it's not
                    .then((userInfo) => {
                      submit.disabled = false;
                      if (APIHandler.ok(userInfo.response)) {
                        APIHandler.setSfUser(email, appId, userInfo.response).then(() => {
                          this.login(userInfo, true);
                        });
                      } else {
                        const { userInput } = this.state;
                        userInput.reg_email = email;
                        this.setState({
                          display: 'registerQuick',
                          userInput,
                        });
                      }
                    });
                });
              }
            });
          } else {
            StorageHandler.load(storageKeys.user).then((userInfo) => {
              // Loads userInfo from localStorage
              submit.disabled = false;
              this.login(userInfo, false);
            });
          }
        });
    } else {
      submit.disabled = false;
    }
  }

  changeHandler(event) {
    const input = this.state.userInput;
    input[event.target.name] = event.target.value || event.target.checked;
    this.setState({ userInput: input });
  }

  changeItemHandler(event, name) {
    const input = this.state.userInput;
    input[name] = event;
    this.setState({ userInput: input });
  }

  registerHandlerFirebase(event) {
    const submit = event.target;
    submit.disabled = true;
    event.preventDefault();
    this.setAnim('loadingAnimRegister', true);

    const email = this.state.userInput.reg_email;
    const password = this.state.userInput.reg_password;
    const passwordConfirm = this.state.userInput.reg_passwordConfirm;

    if (!checkInputValidity()) {
      const invalidFields = `Please fill in all the required fields: ${checkInputValidityFields().join(', ')}`;
      toast.error(invalidFields, {
        position: 'top-center',
        transition: Zoom,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      this.setAnim('loadingAnimRegister', false);
      return;
    }

    if (password !== passwordConfirm) {
      toast.error('The passwords you entered do not match', {
        position: 'top-center',
        transition: Zoom,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      this.setAnim('loadingAnimRegister', false);
      return;
    }

    if (password.length < 6) {
      toast.error('Password needs to be at least 6 characters.', {
        position: 'top-center',
        transition: Zoom,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      submit.disabled = false;
      this.setAnim('loadingAnimRegister', false);
      return;
    }

    APIHandler.registerFirebaseUser(email, password).then((firebaseUser) => {
      if (firebaseUser.error) {
        toast.error('This email address already exists or is invalid. Please try with another email address', {
          position: 'top-center',
          transition: Zoom,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        submit.disabled = false;
        this.setAnim('loadingAnimRegister', false);
      } else {
        StorageHandler.exists(storageKeys.user).then((res) => {
          if (!res && checkInputValidity()) {
            let lang = localStorage.getItem('lang');
            lang = JSON.parse(lang);
            lang = lang.rawData;

            this.setAnim('loadingAnimRegister', true);
            const info = this.state.userInput;
            const registerObject = {
              first_name: info.reg_first_name,
              last_name: info.reg_last_name,
              agency_name: info.reg_agency_name,
              state: info.reg_state,
              marketing_opt_in: info.reg_marketing_opt_in,
              country: lang.code,
            };

            DataHandler.matchAppId().then((appId) => {
              APIHandler.setUser(info.reg_email, this.state.appId, registerObject).then(() => {
                APIHandler.getUserOld(appId, info.reg_email).then((newUser) => {
                  StorageHandler.save(storageKeys.refreshToken, firebaseUser.refreshToken);
                  StorageHandler.save(storageKeys.idToken, firebaseUser.idToken, 180000);
                  submit.disabled = false;

                  if (this.props.path === '/register-mobile') {
                    window.setTimeout(() => {
                      window.postMessage('back');
                      window.postMessage('back', '*');

                      window.ReactNativeWebView.postMessage('back');
                      window.ReactNativeWebView.postMessage('back', '*');
                    }, 1000);
                  } else {
                    this.login(newUser, true, '/main');
                  }
                });
              });
            });
          } else {
            submit.disabled = false;
          }
        });
      }
    });
  }

  registerHandler(event) {
    const submit = event.target;
    submit.disabled = true;
    event.preventDefault();
    StorageHandler.exists(storageKeys.user).then((res) => {
      if (!res && checkInputValidity()) {
        let lang = localStorage.getItem('lang');
        lang = JSON.parse(lang);
        lang = lang.rawData;

        this.setAnim('loadingAnimRegister', true);
        const info = this.state.userInput;
        const registerObject = {
          first_name: info.reg_first_name,
          last_name: info.reg_last_name,
          agency_name: info.reg_agency_name,
          state: info.reg_state,
          marketing_opt_in: info.reg_marketing_opt_in,
          country: lang.code,
        };

        let email = info.reg_email;
        if (info.reg_email === '') {
          email = localStorage.getItem('email');
          email = JSON.parse(email);
          email = email.rawData;
          DataHandler.matchAppId().then((appId) => {
            APIHandler.setUser(email, this.state.appId, registerObject).then(() => {
              APIHandler.setSfUser(email, this.state.appId, registerObject).then(() => {
                APIHandler.getUserOld(appId, email).then((newUser) => {
                  submit.disabled = false;
                  this.login(newUser.response, true, '/main');
                });
              });
            });
          });
        } else {
          DataHandler.matchAppId().then((appId) => {
            APIHandler.setUser(email, this.state.appId, registerObject).then(() => {
              APIHandler.setSfUser(email, this.state.appId, registerObject).then(() => {
                APIHandler.getUserOld(appId, email).then((newUser) => {
                  submit.disabled = false;

                  if (this.props.path === '/register-mobile') {
                    window.setTimeout(() => {
                      window.postMessage('back');
                      window.postMessage('back', '*');

                      window.ReactNativeWebView.postMessage('back');
                      window.ReactNativeWebView.postMessage('back', '*');
                    }, 1000);
                  } else if (this.props.path === '/existing-mobile') {
                    window.setTimeout(() => {
                      window.postMessage('back');
                      window.postMessage('back', '*');

                      window.ReactNativeWebView.postMessage('back');
                      window.ReactNativeWebView.postMessage('back', '*');
                    }, 1000);
                  } else {
                    this.login(newUser.response, true, '/main');
                  }
                });
              });
            });
          });
        }
      } else {
        submit.disabled = false;
      }
    });
  }

  registerExistingHandler(event) {
    const submit = event.target;
    submit.disabled = true;
    event.preventDefault();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const email = urlParams.get('email');

    // Mobile only flow get user from url param
    this.setAnim('loadingAnimRegister', true);
    const info = this.state.userInput;
    const registerObject = {
      email: info.reg_email,
      first_name: info.reg_first_name,
      last_name: info.reg_last_name,
      agency_name: info.reg_agency_name,
      state: info.reg_state,
      marketing_opt_in: info.reg_marketing_opt_in,
      country: 'US',
    };

    console.log('existing user', registerObject);
    DataHandler.matchAppId().then((appId) => {
      APIHandler.setUser(info.reg_email, this.state.appId, registerObject).then(() => {
        APIHandler.setSfUser(info.reg_email, this.state.appId, registerObject).then(() => {
          APIHandler.getUserOld(appId, info.reg_email).then((newUser) => {
            submit.disabled = false;

            window.setTimeout(() => {
              if (
                window.location.href.includes('/register-mobile') ||
                window.location.href.includes('/quick-register-mobile')
              ) {
                window.postMessage('back');
                window.postMessage('back', '*');

                window.ReactNativeWebView.postMessage('back');
                window.ReactNativeWebView.postMessage('back', '*');
              } else {
                console.log('existing user2 ', newUser.response);
                this.login(newUser, true, '/main');
              }
            }, 1000);
          });
        });
      });
    });
  }

  forgotHandler(event) {
    const submit = event.target;
    submit.disabled = true;
    event.preventDefault();
    const { email } = this.state.userInput;
    this.setAnim('loadingAnimForgot', true);
    APIHandler.forgotFirebasePassword(email).then((firebaseRes) => {
      if (firebaseRes.error) {
        this.setAnim('loadingAnimForgot', false);
        submit.disabled = false;
        toast.error("The email you've entered doesn't match any account.", {
          position: 'top-center',
          transition: Zoom,
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        this.setAnim('loadingAnimForgot', false);
        submit.disabled = false;
        toast.success(
          'We’ve sent instructions on how to change your password to the submitted email addresses. You will be automatically redirected to the login page after 10 seconds.',
          {
            position: 'top-center',
            transition: Zoom,
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          },
        );
        window.setTimeout(() => {
          window.location.href = '/login';
        }, 10000);
      }
    });
  }

  resendHandler() {
    APIHandler.resendVerificationLink(this.state.resend_link).then((res) => {
      if (res.success) {
        toast.success(res.message, {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        this.setState({ resend_link: '' });
      }
    });
  }

  render() {
    const { animation, display, message, redirect, userInput } = this.state;

    return (
      <form className="login__form">
        {display === 'login' && (
          <Email
            submit={this.loginHandler}
            defaultVal={userInput.email}
            change={this.changeHandler}
            loadingAnim={animation.loadingAnim}
            signUpRoute={this.signUpRoute}
            forgotPasswordRoute={this.forgotPasswordRoute}
          />
        )}
        {display === 'forgot' && (
          <Forgot
            back={this.backHandler}
            defaultVal={userInput.email}
            submit={this.forgotHandler}
            change={this.changeHandler}
            loadingAnimRegister={animation.loadingAnimForgot}
          />
        )}

        {display === 'registerPassword' && (
          <Register
            country={userInput.reg_country}
            passwordField
            back={this.backHandler}
            submit={this.registerHandlerFirebase}
            change={this.changeHandler}
            changeItem={this.changeItemHandler}
            loadingAnimRegister={animation.loadingAnimRegister}
            data={userInput}
          />
        )}

        {display === 'existingMobile' && (
          <Register
            submit={this.registerExistingHandler}
            back={this.backHandler}
            defaultVal={userInput.email}
            change={this.changeHandler}
            loadingAnimRegister={animation.loadingAnimRegister}
            passwordField={false}
          />
        )}

        {display === 'registerQuick' && (
          <Register
            country={userInput.reg_country}
            data={userInput}
            back={this.backHandler}
            submit={this.registerExistingHandler}
            change={this.changeHandler}
            changeItem={this.changeItemHandler}
            loadingAnimRegister={animation.loadingAnimRegister}
            passwordField={false}
          />
        )}

        <h3 className="form__message">{message}</h3>

        {redirect.length > 0 && <Redirect push to={redirect} />}
        <p className="legal">
          {i18n.translate('loginScreen.tAndC.agree')}
          <span
            role="button"
            tabIndex={-1}
            data-fancybox="privacy"
            data-type="iframe"
            href="https://travpromobile.com/privacy_policy.html"
          >
            {i18n.translate('loginScreen.tAndC.privacyPolicy')}
          </span>
          {i18n.translate('loginScreen.tAndC.and')}
          <span
            role="button"
            tabIndex={0}
            data-fancybox="terms"
            data-type="iframe"
            href="https://travpromobile.com/terms_of_use.html"
          >
            {i18n.translate('loginScreen.tAndC.termsConditions')}
          </span>
          {'.'}
        </p>
        {this.props.path === '/register-mobile' && (
          <style>
            {
              '\
        .buttonWrapper { display: none !important; }.loginView__content--logo { display: none !important; } .btnInverse { display: none !important; } .cookieConsent { display: none; bottom: 4rem; } .register { display: none !important; } .loginView .loginView__bg .loginView__bg--content .buttonWrapper img { display: none !important; } #openWidget { display: none !important; }'
            }
          </style>
        )}
        <SweetAlert
          html
          onConfirm={() => {
            this.setState({ admission_message: '' });
          }}
          show={!!this.state.admission_message}
          confirmButtonText="Ok"
          text={this.state.admission_message}
        />
        <SweetAlert
          html
          title="Email not Verified:"
          onConfirm={() => {
            this.setState({ verified_message: '' });
          }}
          onCancel={() => {
            this.setState({ verified_message: '' });
            this.resendHandler();
          }}
          show={!!this.state.verified_message}
          confirmButtonText="Ok"
          cancelButtonText="Resend email"
          showCancelButton
          text={this.state.verified_message}
        />
        <ToastContainer draggablePercent={70} />
      </form>
    );
  }
}

LoginForm.propTypes = {
  path: PropTypes.string,
};

LoginForm.defaultProps = {
  path: '/login',
};
